import "babel-polyfill";
import Vue from 'vue';
import Download from '../views/scanner-download'
import '../assets/css/style.css'
window.isCdn = true

new Vue({
    // router,
    // store,
    // i18n,
    render: h => h(Download)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/entry/download-cdn.js